import DataTable from "./components/DataTable.vue";
import { languageServiceProvider } from "./lang.js";
export {
	DataTable,
	DataTable as default,
	languageServiceProvider
};
